import React from 'react';
import { Alert, Card } from 'react-bootstrap';
import { FaUser, FaClock, FaExchangeAlt } from 'react-icons/fa';
import moment from 'moment';

const OrderLogs = ({ logs }) => {
    const orderStatusInternal = JSON.parse(localStorage.getItem("order_status"));
    return (
        <div className="p-3 mb-3">
            <div className="timeline">
                {logs ? [...logs]
                    .sort((a, b) => new Date(b.order_status_changed_on) - new Date(a.order_status_changed_on))
                    .map((log, index) => (
                        <div key={index} className="d-flex align-items-start mb-3">
                            <div className="me-3 text-primary fs-5"><FaExchangeAlt /></div>
                            <div>
                                <div className="fw-bold">
                                    Status changed to <span className="text-success">{orderStatusInternal[log.order_status]}</span>
                                </div>
                                <div className="text-muted small">
                                    <FaUser className="me-1" />
                                    {log.order_status_changed_by_username}
                                    &nbsp;&nbsp;|&nbsp;&nbsp;
                                    <FaClock className="me-1" />
                                    {moment(log.order_status_changed_on).format('MMM DD, YYYY hh:mm A')}
                                </div>
                            </div>
                        </div>
                    )) : <Alert variant="info" className="text-center">
                        <strong>No Order Logs Available</strong>
                    </Alert>
                }
            </div>
        </div>
    );
};

export default OrderLogs;
